import {Easing} from 'motion';

export const DEFAULT_DURATION = 0.6; // seconds
export const DEFAULT_CUBIC: Easing = [0.625, 0.05, 0, 1];
